module.exports = __webpack_public_path__ + "static/img/news1.842c14d1.png";